export default "__VITE_ASSET__CLn9Zkoy__"